export function initShowPasswordToggle(selector, options = {}) {
  const settings = {
    iconShow: "👁️",
    iconHide: "🙈",
    iconClass: "ladzo-toggle-password",
    wrapperClass: "ladzo-password-wrapper",
    iconPosition: "right",
    offset: "10px",
    ...options,
  };

  document.querySelectorAll(selector).forEach((input) => {
    // wrapper
    const wrapper = document.createElement("div");
    wrapper.classList.add(settings.wrapperClass);
    wrapper.style.position = "relative";
    //wrapper.style.display = "inline-block";

    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    // toggle ikonka
    const toggle = document.createElement("span");
    toggle.classList.add(settings.iconClass);
    toggle.innerHTML = settings.iconShow;
    Object.assign(toggle.style, {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      [settings.iconPosition]: settings.offset,
    });

    input.after(toggle);

    toggle.addEventListener("click", () => {
      const isPassword = input.type === "password";
      input.type = isPassword ? "text" : "password";
      toggle.innerHTML = isPassword ? settings.iconHide : settings.iconShow;
    });
  });
}
